import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledConversationMessageList = styled.div`
    flex: 1;
    overflow-y: auto;
    border-right: 1px solid var(--color-grey-700);
    .conversation-preview-container {
        box-sizing: border-box;
        width: 100%;
        max-height: 104px;
        padding: 16px 16px 16px 16px;
        cursor: pointer;
        background-color: var(--color-white);
        border-bottom: 1px solid var(--color-grey-700);
        @media ${breakpoints.xs} {
            max-height: inherit;
        }
        .archive {
            display: flex;
            align-items: center;
            padding-right: 4px;
            padding-left: 4px;
            margin-right: 8px;
            font-size: var(--size-12);
            font-weight: bold;
            line-height: 18px;
            color: var(--color-tertiary-fg);
            background-color: var(--color-tertiary);
            border-radius: var(--radius-5);
        }
        .readonly {
            display: flex;
            align-items: center;
            padding-right: 4px;
            padding-left: 4px;
            margin-right: 8px;
            font-size: var(--size-12);
            font-weight: bold;
            line-height: 18px;
            color: var(--color-white);
            background-color: var(--color-info);
            border-radius: var(--radius-5);
        }
        .conversation-preview-title {
            flex: 3 0 0;
            overflow: hidden;
            font-size: var(--size-16);
            line-height: 24px;
            color: var(--color-secondary);
            text-align: start;
            text-overflow: ellipsis;
            white-space: nowrap;
            @media ${breakpoints.xs} {
                white-space: inherit;
            }
        }
        .conversation-preview-message {
            display: -webkit-box !important;
            margin-left: 17px;
            overflow: hidden;
            font-size: var(--size-14);
            line-height: 24px;
            color: var(--color-grey-800);
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            > * {
                margin: 0;
                text-overflow: ellipsis;
                white-space: nowrap;
                br {
                    display: none;
                }
            }
        }
        .conversation-preview-date {
            font-size: var(--size-14);
            line-height: 24px;
            color: var(--color-grey-800);
        }
        .unreadDot,
        .unreadSpacer {
            width: 9px;
            height: 9px;
            margin-right: 8px;
        }
        .unreadDot {
            background-color: var(--color-tertiary);
            border-radius: var(--radius-50);
        }
        .conversation-preview-title-container {
            flex: 1 100%;
            flex-flow: row wrap;
            margin-bottom: 8px;
        }
        &:nth-child(1) {
            border-top: 1px solid var(--color-grey-700);
        }
        &.selected {
            background: var(--color-primary);
            .conversation-preview-title {
                color: var(--color-primary-fg);
            }
            .conversation-preview-message,
            .conversation-preview-date {
                color: var(--color-grey-700);
            }
        }
        &.unread {
            background: var(--color-selected);
            .conversation-preview-title {
                font-weight: bold;
            }
        }
    }
`;
